var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}]},[_c('p',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.subtitle))]),_vm._v(" "),_c('div',{class:_vm.classes},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }